import { render, staticRenderFns } from "./FieldList.vue?vue&type=template&id=83d0f1a6&scoped=true&"
import script from "./FieldList.vue?vue&type=script&lang=js&"
export * from "./FieldList.vue?vue&type=script&lang=js&"
import style0 from "./FieldList.vue?vue&type=style&index=0&id=83d0f1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d0f1a6",
  null
  
)

export default component.exports